import { useMutation } from 'urql';
import { gql } from 'urql';

export const DELETE_SEGEMENT_MUTATION = gql`
  mutation ($segmentId: [Int!]!) {
    deleteTicketSegment(segmentId: $segmentId) {
      success
      rowsAffected
    }
  }
`;

export interface IDeleteSegmentVariables {
  segmentId: number;
}

export interface IDeleteSegmentResponse {
  deleteTicketSegment: {
    success: boolean;
    rowsAffected: number;
  };
}

export const useFetchDeleteSegment = () => {
  return useMutation<IDeleteSegmentResponse, IDeleteSegmentVariables>(DELETE_SEGEMENT_MUTATION);
};
